export default __webpack_public_path__ + "static/media/home.2281d115.svg";